import React from "react";
import "./NotificationsModal.css";
import FormatDateTime from "../../../utils/formatDateTime/FormatDateTime.js";
import { notifications } from "../../../config/constants";

const NotificationsModal = () => {
  return (
    <>
      {/* <section className="container notification-board-container"> */}
      <div className="inner-container-first notification-list-container notification-modal-list">
        <div className="scrollable-inner">
          <ul className="notification-list">
            {notifications.map((notification, index) => {
              const isNew =
                new Date() - new Date(notification.datetime) <
                48 * 60 * 60 * 1000;
              return (
                <li
                  key={index}
                  className={`notification-container ${isNew ? "shimmer-bg" : ""}`}
                >
                  <h3 className="h3-secondary notification-headline">
                    &#x2022; {notification.heading}
                    {isNew && <span>New</span>}
                  </h3>
                  <p className="notification-details">{notification.details}</p>
                  {notification.attachment && (
                    <a
                      className="detail-postfix"
                      href={notification.attachment}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <p className="paperclip-icon">&#128206;</p> View
                      Attachment
                    </a>
                  )}
                  <div className="notification-footer">
                    <p className="clock-icon">&#128336;</p>
                    <div>{FormatDateTime(notification.datetime)}</div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      {/* </section> */}
    </>
  );
};

export default NotificationsModal;
